import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { MenuService } from '../services/menu.service';
import { AuthService } from '../services/auth.service';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state) => {
  const menuService = inject(MenuService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // Platform Head bypass
  const role = authService.currentUser()?.role?.toUpperCase();
  if (role === 'PLATFORM_HEAD' || role === 'PLATFROM_HEAD') {
    return true;
  }

  const routePath = state.url;
  const actionRequired = (route.data?.['requiredAction'] || 'canView') as 'canView' | 'canCreate' | 'canEdit' | 'canDelete' | 'canApprove';

  const isAllowed = menuService.hasPermission(routePath, actionRequired);

  if (!isAllowed) {
    // Redirect to dashboard if unauthorized
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
